module.exports = __webpack_public_path__ + "static/media/emailicon.34b691a4.png";